import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import ComponentTable from '../../../Components/Table/Index';
import { Column } from '../../../Components/Table/Types';
import * as Icon from '@mui/icons-material/';
import { useNavigate } from 'react-router-dom';
import { Form, Formik, Field } from 'formik';
import { TipoPagamentoAtualizar, TipoPagamentoCadastrar } from '../../../../routes/RoutesNames';
import { IconButton } from '@mui/material';
import { useSelector } from 'react-redux';
import TipoPagamentoController from '../../../../controllers/TipoPagamentoController';
import { Button } from '../../../../shared/components/button/Button';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import { toast } from 'react-toastify';
import { ButtonMenu } from '../../../../shared/components/ButtonMenu';

interface Row {
  BtnEditar?: JSX.Element;
  BtnExcluir?: JSX.Element;
  tpg_id: number;
  tpg_descricao: string;
}

export default function TipoPagamento() {
  const userId = useSelector((state: any) => state.Authentication.userId);
  const navigate = useNavigate();
  const tableColumns: Column[] = [
    { id: 'Id', label: 'Id', minWidth: 0, align: 'center' },
    { id: 'Descricao', label: 'Descrição', minWidth: 0 },
    { id: 'BtnMenu', label: '', width: 60, minWidth: 0, align: 'right' },
  ];
  const initialValues = {
    TipoPagamentoId: null,
    Descricao: '',
  };

  const [tableRows, setTableRows] = useState<Row[]>([]);

  const handleNavigation = async (): Promise<void> => {
    navigate(TipoPagamentoCadastrar);
  };

  const handleEditItem = (item: Row, duploClick = false, duploClickId = 0) => {
    if (duploClick) {
      navigate(TipoPagamentoAtualizar.replace(':id', duploClickId.toString()), { state: { duploClick: true } });
    }
    else {
      navigate(TipoPagamentoAtualizar.replace(':id', item.tpg_id.toString()));
    }
  };

  const handleDeleteItem = async (tpg_id: number) => {
    const request: any = { UsuId: userId, TipoPagamentoId: tpg_id };
    const response = await TipoPagamentoController.Excluir(request);

    if (response.StatusCode === 204) {
      toast('Tipo de pagamento excluído com sucesso!', {
        type: 'success',
      });
    } else {
      toast('Erro ao excluir o tipo de pagamento!', {
        type: 'error',
      });
    }
    await handleSubmit(initialValues)
  };

  const handleSubmit = async (values: any) => {
    const DataRows: any = [];
    const Response = await TipoPagamentoController.Listar(values);

    if (Response.StatusCode === 200 && Response?.Data?.length > 0) {
      Response.Data.map((item: Row) => {
        DataRows.push({      
          Id: item.tpg_id,
          Descricao: item.tpg_descricao,
           BtnMenu: (
            <ButtonMenu
              items={[
                { onClick: () => handleEditItem(item), menu: 'Editar' },
                {
                  onClick: () => handleDeleteItem(item.tpg_id),
                  menu: 'Excluir', confirmar: `Excluir o tipo de pagamento "${item.tpg_descricao ?? ''}"? Esta ação não pode ser desfeita.`,
                },
              ]}
            />
          ),
        });

        setTableRows(DataRows);
      });
    } else if (Response.StatusCode === 204 && Response?.Data?.length === 0) {
      toast('Não há registros cadastrados.', {
        type: 'warning',
      });
    } else {
      toast(Response?.Data, {
        type: 'error',
      });
    }
  };

  useEffect(() => {
    handleSubmit(initialValues)
  }, []);

  return (
    <Box
      sx={{
        '& .MuiTextField-root': { m: 1 },
      }}
    >
      <div className={'pb-2'}>
        <HeaderComponent
          className={'mb-6'}
          text={'TIPOS DE PAGAMENTO'}
          ButtonRight={
            <Button
              className={''}
              variant='success'
              onClick={handleNavigation}
              iconStart={<Icon.Add />}
              title={'Incluir'}
            />
          }
        />
        <Box mb={2} />

        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
        >
          {({ errors }) => (
            <Form className={'grid grid-cols-12 gap-2'}>
              <Field
                className={'col-span-2'}
                name='TipoPagamentoId'
                as={TextField}
                id='outlined-password-input'
                label='Código'
                type='number'
                autoComplete='current-password'
              />
              <Field
                className={'col-span-3'}
                name='Descricao'
                as={TextField}
                label='Descricao'
                type='text'
                error={Boolean(errors?.Descricao)}
                helperText={errors?.Descricao}
              />
              <Box className={'pt-3'}>
                <IconButton size={'large'} type={'submit'}>
                  <Icon.Search style={{ fontSize: '28px' }} />
                </IconButton>
              </Box>
            </Form>
          )}
        </Formik>
      </div>
      <ComponentTable columns={tableColumns} rows={tableRows} onRowDoubleClick={(row) => {
        handleEditItem(row, true, row.Id);
      }} />
    </Box>
  );
}
